<template>
  <div class="login-wrapper border border-light">
     <b-alert v-if = "showAlert" show variant="danger">Не верные логин или пароль</b-alert>
    <form class="form-signin" @submit.prevent="login">
      <h2 class="form-signin-heading">Вход в систему</h2>
      <label for="inputEmail" class="sr-only">Имя</label>
      <input v-model="username" type="text" id="inputEmail" class="form-control" placeholder="имя пользователя" required autofocus>
      <label for="inputPassword" class="sr-only">Пароль</label>
      <input v-model="password" type="password" id="inputPassword" class="form-control" placeholder="пароль" required>
      <label for="inputPbx" class="sr-only">АТС</label>
      <input v-model="pbx" type="text" id="inputPbx" class="form-control" placeholder="имя АТС(опционально)">
      <button class="btn btn-lg btn-primary btn-block" type="submit" :disabled="buttonDisabled" >Войти</button>
    </form>
 
  </div>
</template>

<script>
import config from './config';
import axios from 'axios';
import VueJwtDecode from 'vue-jwt-decode';
export default {
  name: 'Login',
  data () {
    return {
      username: '',
      password: '',
      pbx: '',
      showAlert:false,
      buttonDisabled:false
    }
  },
  methods: {
    login () {
      this.showAlert = false;
      this.buttonDisabled = true;
      // Запрашиваем вход в систему. Если успешно, то редирект на главную + дорисовка списка телефонов.
      let promise = axios({
        method:'post',
        url:`http://${config.ip}:${config.port}/auth/login`,
        headers: {'Access-Control-Allow-Origin': '*'},
        data: {
          username: this.username,
          password: this.password
        }
      });
    return promise.then(res => {
      //console.log(res);
      if(res.data.status == 'success'){
        //login success. store token, decode it, setting role, and redirect to main 
        let token = res.data.data.token;
        localStorage.setItem('token', token)
        let decode = VueJwtDecode.decode(token)
        let phones = decode.phones;
        let contract = decode.contract;
        let authority = {
          contract: contract,
          phones: phones
          }
        localStorage.setItem('auth', authority);
        this.$emit('auth', authority);
        console.log(phones);
        console.log(contract);
        console.log(`login successful`);
        console.log(this.$router);
        this.$router.push(this.$route.query.redirect || '/main')
      }
      else { // login fail
        this.showAlert = true;
        this.buttonDisabled = false;
        console.log(res.data.description[0]);
      }
    }).catch(err => {
      console.log(err);
      this.buttonDisabled = false;
    })
    }
  }
}
</script>

<style lang="css" scoped>
body {
  background: #605B56;
}

.login-wrapper {
  background: #fff;
  width: 70%;
  margin: 12% auto;
}

.form-signin {
  max-width: 330px;
  padding: 10% 15px;
  margin: 0 auto;
}
.form-signin .form-signin-heading,
.form-signin .checkbox {
  margin-bottom: 10px;
}
.form-signin .checkbox {
  font-weight: normal;
}
.form-signin .form-control {
  position: relative;
  height: auto;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  padding: 10px;
  font-size: 16px;
}
.form-signin .form-control:focus {
  z-index: 2;
}
.form-signin input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>


// WEBPACK FOOTER //
// src/Login.vue